/**
 * Helper functions to add interactive features to slide thumbnails
 * when rendered outside the editor
 */

// Create the modal HTML
function createSlideModal() {
  // Only create once
  if (document.getElementById("slide-modal")) return;

  const modal = document.createElement("div");
  modal.id = "slide-modal";
  modal.className = "slide-modal";
  modal.innerHTML = `
    <div class="slide-modal-content">
      <span class="slide-modal-close">&times;</span>
      <div class="slide-modal-header">
        <h3 class="slide-modal-title">Modal Title</h3>
      </div>
      <div class="slide-modal-body">
        <img class="slide-modal-image" src="" alt="Slide">
      </div>
    </div>
  `;

  modal.querySelector(".slide-modal-close").addEventListener("click", () => {
    modal.style.display = "none";
  });

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.style.display === "block") {
      modal.style.display = "none";
    }
  });

  document.body.appendChild(modal);

  const style = document.createElement("style");
  style.textContent = `
    .slide-modal {
      display: none;
      position: fixed;
      z-index: 9999;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgba(0, 0, 0, 0.7);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .slide-modal.show {
      opacity: 1;
    }

    .slide-modal-content {
      position: relative;
      background-color: #fefefe;
      margin: 5% auto;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      width: 80%;
      max-width: 1000px;
      animation: slideIn 0.3s ease;
    }

    @keyframes slideIn {
      from { transform: translateY(-30px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }

    .slide-modal-close {
      position: absolute;
      top: 10px;
      right: 15px;
      color: #aaa;
      font-size: var(--fs-xxl);
      font-weight: bold;
      cursor: pointer;
    }

    .slide-modal-close:hover {
      color: #333;
    }

    .slide-modal-header {
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin-bottom: 15px;
    }

    .slide-modal-body {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .slide-modal-image {
      max-width: 100%;
      max-height: 70vh;
      object-fit: contain;
    }

    /* Mobile styles - portrait orientation */
    @media (max-width: 768px) {
      .slide-modal-content {
        width: 95%;
        margin: 2% auto;
        padding: 15px;
        height: 95vh;
        display: flex;
        flex-direction: column;
      }

      .slide-modal-header {
        padding-bottom: 8px;
        margin-bottom: 10px;
      }

      .slide-modal-title {
        font-size: var(--fs-medium);
        margin: 0;
      }

      .slide-modal-body {
        flex: 1;
        overflow: auto;
      }

      .slide-modal-image {
      max-width: 70vh;
        height: auto;
        transform: rotate(90deg);
        transform-origin: center center;
      }

      .slide-modal-close {
        font-size: 32px;
        top: 5px;
        right: 10px;
        z-index: 10;
      }
    }

    /* Landscape mode on mobile - no rotation needed */
    @media (max-width: 768px) and (orientation: landscape) {
      .slide-modal-image {
        transform: none;
        max-height: 70vh;
      }
    }
  `;

  document.head.appendChild(style);
}

export function setupSlideThumbnailHandlers(rootElement = document) {
  createSlideModal();

  const modal = document.getElementById("slide-modal");

  const thumbnails = rootElement.querySelectorAll(
    '.slide-deck-thumbnail[data-action="view-slide"]'
  );

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      const thumbnailUrl = thumbnail.getAttribute("data-thumbnailurl");
      const title = thumbnail.getAttribute("data-title");

      if (thumbnailUrl) {
        modal.querySelector(".slide-modal-image").src = thumbnailUrl;
        modal.querySelector(".slide-modal-title").textContent =
          title || "Slide View";

        modal.style.display = "block";
        setTimeout(() => {
          modal.classList.add("show");
        }, 10);
      }
    });
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("DOMContentLoaded", () => {
    setupSlideThumbnailHandlers();
  });
}
